import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";
import MDIGITAL_PROPERTY_MESSAGES from "./MDIGITAL_PROPERTY_MESSAGES";
import MDIGITAL_MODAL_DIALOGS from "./MDIGITAL_MODAL_DIALOGS"
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';

  var CURRENT_SHOWN_MODAL_INITIAL_STATE = {
    formId: null,
    targetModalId: '',
  };
  var rootWindow = window.top;
  var currentShownModal = {};

  function init() {
    initModalState();
    KAMPYLE_EVENT_DISPATCHER.subscribeMany({
      // modal open events
      neb_formShown: [onFormShown],
      neb_formPageShown: [safariFocusOnFirstPageShown],
      neb_inviteReady: [onInviteReady],
      MDigital_noJsonModalShown: [onNoJsonModalShown],
      // modal closed events
      neb_afterFormClosed: [onFormClosed],
      neb_inviteAccepted: [onInviteAccepted],
      neb_inviteDeclined: [onInviteDeclined],
      MDigital_noJsonModalClosed: [onNoJsonModalClosed],
      //others
      neb_captureImageClicked: [refocusForm],
      MDigital_Capture_Cancelled: [refocusForm],
    });
  }

  function initModalState() {
    Object.assign(currentShownModal, CURRENT_SHOWN_MODAL_INITIAL_STATE);
  }

  function setModalState(newState) {
    Object.assign(currentShownModal, newState);
  }

  // for testing purpose only
  function getModalState() {
    return currentShownModal;
  }

  function onFormShown(eventName, payload) {
    var formId = payload.formId;

    setLocalizedAnnouncementOnForm(formId);

    if (KAMPYLE_UTILS.isModalFormType(formId)) {
      setModalState({
        formId: formId,
        focusedElement: isEventOccuredOnCurrentShownModal(formId) ? currentShownModal.focusedElement : document.activeElement,
        targetModalId: KAMPYLE_DATA.getFormIframeId(formId),
        isNoJsonModal: false,
        // if running in preview we do not apply focus trap to be able to focus display settings to simulate custom params
        isPreview: KAMPYLE_UTILS.isFormInPreviewContext()
      });

      setDialogAriaAttributesOnForm(formId);
      if (KAMPYLE_DATA.isCustomHtmlForm(formId) && KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.IS_CHTML_HANDLE_INIT_FOCUS_INDEPENDENTLY)) {
        MDIGITAL_MODAL_DIALOGS.trapFocus();
      }
      else if ((KAMPYLE_DATA.isCustomHtmlForm(formId) && !KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.IS_CHTML_HANDLE_INIT_FOCUS_INDEPENDENTLY)) ||
               (KAMPYLE_UTILS.isSafari() && !KAMPYLE_UTILS.shouldFocusIframeOnPageShown())) {
        initAndTrapFocusOnModal();
      }
      else {
        MDIGITAL_MODAL_DIALOGS.trapFocus();
      }
    }
  }

  function onInviteReady(eventName, payload) {
    var formId = payload.formId;

    setLocalizedAnnouncementOnInvite(formId);

    if (KAMPYLE_DATA.isNewMobileInvitation()) {
      return;
    }

    setModalState({
      formId: formId,
      focusedElement: document.activeElement,
      targetModalId: KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.IFRAME_ID,
      isNoJsonModal: false,
      isPreview: false
    });

    setDialogAriaAttributesOnInvite(formId);

    if (KAMPYLE_UTILS.isSafari()) {
      initAndTrapFocusOnModal();
    }
    else {
      MDIGITAL_MODAL_DIALOGS.trapFocus();
    }

  }

  function onNoJsonModalShown(eventName, payload) {
    setModalState({
      formId: payload.formId,
      focusedElement: document.activeElement,
      targetModalId: KAMPYLE_CONSTANT.IFRAME_SETTINGS.OOPS.CONTAINER_ID_PREFIX + payload.formId,
      isNoJsonModal: true,
      isPreview: false
    });

    setDialogAriaAttributesOnOops();
    MDIGITAL_MODAL_DIALOGS.focusOnOopsCloseButton();
    MDIGITAL_MODAL_DIALOGS.trapFocus();
  }

  function isEventOccuredOnCurrentShownModal(formId) {
    return formId != null && formId == currentShownModal.formId;
  }


  function onFormClosed(eventName, payload) {
    if (!isEventOccuredOnCurrentShownModal(payload.formId)) {
      // in case where Embedded form on the same page was closed
      return;
    }
    restoreLightBoxDefaultState();
  }

  function onInviteAccepted(eventName, payload) {
    if (!isEventOccuredOnCurrentShownModal(payload.formId)) {
      // in case where new mobil layout invite is used
      return;
    }
    releaseFocus();
    removeDialogAriaAttributesInvite();
    setModalState({
      targetModalId: null
    })
  }

  function onInviteDeclined(eventName, payload) {
    if (!isEventOccuredOnCurrentShownModal(payload.formId)) {
      // in case where new mobil layout invite is used
      return;
    }
    restoreInviteDefaultState();
  }

  function onNoJsonModalClosed(eventName, payload) {
    restoreLightBoxDefaultState();
  }

  function restoreInviteDefaultState() {
    releaseFocus();
    removeDialogAriaAttributesInvite();
    restoreFocus();
    initModalState();
  }

  function restoreLightBoxDefaultState() {
    releaseFocus();
    removeDialogAriaAttributesLightBox();
    restoreFocus();
    initModalState();
  }

function handleTrapFocus() {
    var kFormContainer = document.getElementById('kampyleFormContainer');
    var isPartialViewStyle = kFormContainer.style.pointerEvents === 'none';
    if (kFormContainer && isPartialViewStyle) {
        return;
    }
    setFocus();
}

  function trapFocus() {
    if (currentShownModal.isPreview) return;
    try {
        rootWindow.addEventListener(KAMPYLE_CONSTANT.BROWSER_EVENTS.FOCUS, handleTrapFocus, true);
    } catch (e) {
        handleRootWindowError(e)
    }
  }

  function releaseFocus() {
    if (currentShownModal.isPreview) return;
    try {
        rootWindow.removeEventListener(KAMPYLE_CONSTANT.BROWSER_EVENTS.FOCUS, handleTrapFocus, true);
    } catch (e) {
        handleRootWindowError(e)
    }
  }

  function handleRootWindowError(e) {
      if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":false,"isGAEnabled":true,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
          MDIGITAL_ANALYTICS.triggerDigitalAnalyticsEventDispatcherError({ errorMessage: e.message, errorStack: e.stack });
      }
      if(MDIGITAL_LOGGER.getLoggerStatus()){
          MDIGITAL_LOGGER.error(e);
      }
  }

  function refocusForm() {
    var targetModal = document.getElementById(currentShownModal.targetModalId);
    if (targetModal && targetModal.contentWindow) {
      targetModal.contentWindow.focus();
    }
  }

  function setFocus() {
    if (currentShownModal.isNoJsonModal) {
      focusOnOopsCloseButton();
    }
    else {
      focusOnModal();
    }
  }

  function safariFocusOnFirstPageShown(event, data) {
    if (Number(data.pageNumber) === 0 && KAMPYLE_UTILS.isModalFormType(data.formId) && 
      KAMPYLE_UTILS.isSafari() && KAMPYLE_UTILS.shouldFocusIframeOnPageShown() &&
      !(KAMPYLE_DATA.isCustomHtmlForm(data.formId))) {
        initAndTrapFocusOnModal();
    }
  }

  function initAndTrapFocusOnModal() {
    MDIGITAL_MODAL_DIALOGS.focusOnModal();
    MDIGITAL_MODAL_DIALOGS.trapFocus();
  }

  function focusOnModal() {
    var targetModal = document.getElementById(currentShownModal.targetModalId);
    KAMPYLE_UTILS.focusElement(targetModal);
  }

  function focusOnOopsCloseButton() {
    var closeButton = document.querySelector("#" + currentShownModal.targetModalId + " #" + KAMPYLE_CONSTANT.IFRAME_SETTINGS.OOPS.CLOSE_BUTTON_ID);
    KAMPYLE_UTILS.focusElement(closeButton);
  }

  function restoreFocus() {
    var elementToFocus = currentShownModal.focusedElement;
    if (elementToFocus != null && elementToFocus !== document.body) {
      KAMPYLE_UTILS.focusElement(elementToFocus);
    }
    else if (document.activeElement !== document.body && KAMPYLE_UTILS.isSafari()) {
      var targetModal = document.getElementById(currentShownModal.targetModalId);
      if (targetModal != null && document.activeElement === targetModal) {
        window.focus();
        enforceFocusOnBody();
      }
    }
  }

  function setDialogAriaAttributesOnForm(formId) {
    var ariaAttrs = {
      role: "dialog",
      'aria-modal': true,
      'aria-label': getFormAnnouncement(formId),
    }
    var langCode = getFormLanguageCode(formId);

    removeDialogAriaAttributesLightBox();
    setDialogAriaAttributesLightBox(Object.assign(ariaAttrs, { lang: langCode }), formId);
  }

  function setDialogAriaAttributesOnInvite(formId) {
    var ariaAttrs = {
      role: 'dialog',
      'aria-modal': true,
      'aria-label': getInviteAnnoucement(formId),
    }
    var langCode = getFormLanguageCode(formId);

    removeDialogAriaAttributesInvite();
    setDialogAriaAttributesInvite(langCode != null ? Object.assign(ariaAttrs, { lang: langCode }) : ariaAttrs);
  }

  function setDialogAriaAttributesOnOops() {
    var ariaAttrs = {
      role: "alertdialog",
      'aria-modal': true,
      'aria-labelledby': 'title-no-json-modal',
      'aria-describedby': 'description-no-json-modal',
    }
    var langCode = getPropertyMessageLanguageCode();

    removeDialogAriaAttributesLightBox();
    setDialogAriaAttributesLightBox(langCode != null ? Object.assign(ariaAttrs, { lang: langCode }) : ariaAttrs);
  }

  function setDialogAriaAttributesLightBox(attributes, formId) {
    var formIdToUse = KAMPYLE_UTILS.isSafari() && KAMPYLE_UTILS.shouldFocusIframeOnPageShown() ? formId : undefined;
    var element = formIdToUse
      ? KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + formIdToUse
      : KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.CONTAINER_ID_PREFIX;
    MDIGITAL_MODAL_DIALOGS.setDialogAriaAttributes(element, attributes);
  }

  function setDialogAriaAttributesInvite(attributes) {
    MDIGITAL_MODAL_DIALOGS.setDialogAriaAttributes(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.WRAPPER_ID, { 'aria-live': 'polite' });
    MDIGITAL_MODAL_DIALOGS.setDialogAriaAttributes(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.CONTAINER_ID, attributes);
  }

  function enforceFocusOnBody() {
    //create temporary an empty element, focus on it and remove it to enforce focus is moved to body
    var tempFocusHolder = document.createElement('div');
    KAMPYLE_UTILS.addAttributesOnElement(tempFocusHolder, { tabindex: "-1", "aria-hidden":true });
    document.body.appendChild(tempFocusHolder);

    tempFocusHolder.focus();
    tempFocusHolder.remove();
  }

  function getPropertyMessageLanguageCode() {
    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.PROPERTY_MESSAGES) ? MDIGITAL_PROPERTY_MESSAGES.getPropertyMessageLanguageCode() : null;
  }

  function getFormLanguageCode(formId) {
    return MDIGITAL_LOCALIZATION.getFormLanguage(formId);
  }


  function setDialogAriaAttributes(targetId, attributes) {
    var target = document.getElementById(targetId);
    if (target == null) return;

    KAMPYLE_UTILS.addAttributesOnElement(target, attributes);
  }

  function removeDialogAriaAttributesLightBox() {
    removeDialogAriaAttributes(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.CONTAINER_ID_PREFIX);
  }

  function removeDialogAriaAttributesInvite() {
    removeDialogAriaAttributes(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.WRAPPER_ID);
    removeDialogAriaAttributes(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.CONTAINER_ID);
  }

  function removeDialogAriaAttributes(targetId) {
    var target = document.getElementById(targetId);
    if (target == null) return;

    var attributes = ['role', 'aria-modal', 'aria-label', 'aria-labelledby', 'aria-describedby', 'lang', 'aria-live']
    for (var key in attributes) {
      KAMPYLE_UTILS.removeAttribute(target, attributes[key]);
    }
  }

  function getFormAnnouncement(formId) {
    var title;
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION)) {
      title = KAMPYLE_DATA.getMemoryJsonNestedPropertyValue(formId, "settings.formBasicSettings.formAnnouncement", false);
    }
    return title || KAMPYLE_CONSTANT.IFRAME_SETTINGS.IFRAME_TITLE;
  }

  function getInviteAnnoucement(formId) {
    var title;
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION)) {
      title = KAMPYLE_DATA.getMemoryJsonNestedPropertyValue(formId, "invitationAnnouncement", true);
    }
    return title || KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.IFRAME_TITLE;
  }

  function setLocalizedAnnouncementOnForm(formId) {
    var iFrameId = KAMPYLE_DATA.getFormIframeId(formId);
    if (iFrameId == null) return;
    var iFrame = document.getElementById(iFrameId);
    if (iFrame != null) {
      iFrame.title = getFormAnnouncement(formId);
    }
  }

  function setLocalizedAnnouncementOnInvite(formId) {
    var iFrame = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.IFRAME_ID);
    if (iFrame != null) {
      iFrame.title = getInviteAnnoucement(formId);
    }
  }


  export default {
    init: init,
    // for testing
    initModalState: initModalState,
    onFormShown: onFormShown,
    onInviteReady: onInviteReady,
    onNoJsonModalShown: onNoJsonModalShown,
    getModalState: getModalState,
    setModalState: setModalState,
    setFocus: setFocus,
    focusOnModal: focusOnModal,
    focusOnOopsCloseButton: focusOnOopsCloseButton,
    trapFocus: trapFocus,
    refocusForm: refocusForm,
    safariFocusOnFirstPageShown: safariFocusOnFirstPageShown,
    setDialogAriaAttributes: setDialogAriaAttributes,
    setLocalizedAnnouncementOnForm: setLocalizedAnnouncementOnForm,
    setLocalizedAnnouncementOnInvite: setLocalizedAnnouncementOnInvite,
    CURRENT_SHOWN_MODAL_INITIAL_STATE: CURRENT_SHOWN_MODAL_INITIAL_STATE
  }
